// extracted by mini-css-extract-plugin
export default {"wrap":"GK-z","title":"HK-z","cta":"IK-z","disabled":"JK-z","productSearchCard":"KK-z"};